import type {GraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import {buildItemPickersBulkActionsUrl} from '@github-ui/item-picker-base/api/urls'
import type {BulkActionQueryTarget} from '@github-ui/item-picker-base/ItemPicker'
import {UpdateIssuesBulk, UpdateIssuesBulkByQuery} from '@github-ui/server-persisted-queries'
import type {UpdateIssuesBulkMutation} from '@github-ui/server-persisted-queries/types/UpdateIssuesBulk'
import type {UpdateIssuesBulkByQueryMutation} from '@github-ui/server-persisted-queries/types/UpdateIssuesBulkByQuery'
import {type JSONRequestInit, reactFetchJSON} from '@github-ui/verified-fetch'

export type UpdateIssueProjectBulkRequest = {
  ids: string[]
  queryTarget?: BulkActionQueryTarget
  addToProjectIds?: string[]
  removeFromProjectIds?: string[]
}

export type UpdateIssueProjectBulkResponse = GraphQLResponse<
  Partial<UpdateIssuesBulkMutation & UpdateIssuesBulkByQueryMutation>
>

export async function apiUpdateIssueProjectBulk({
  ids,
  queryTarget,
  addToProjectIds,
  removeFromProjectIds,
}: UpdateIssueProjectBulkRequest): Promise<UpdateIssueProjectBulkResponse> {
  const requestUrl = buildItemPickersBulkActionsUrl()
  const body = {
    ...(queryTarget ?? {ids}),
    addToProjectIds,
    removeFromProjectIds,
    queryId: queryTarget ? UpdateIssuesBulkByQuery : UpdateIssuesBulk,
  }

  const init: JSONRequestInit = {
    method: 'POST',
    body,
  }

  const request = await reactFetchJSON(requestUrl, init)

  return (await request.json()) as UpdateIssueProjectBulkResponse
}
